import React, { Component } from 'react'
import { Button, Divider, Modal, Grid, Container } from 'semantic-ui-react'
import { base, ref } from '../../../../config/constants.js'
import { TopMenu } from '../../newDashboard/DashboardParts'
import OrderCard from '../../newDashboard/OrderCard'
import * as UiConsts from '../../../../config/UiConstants'
import {sendNewOrder} from '../../newDashboard/Reporting/ReportingUtils'
import { firebaseAuth } from '../../../../config/constants.js'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import Status from '../../../../config/OrderStatusConstants'
import * as Utils from '../../../../Utilities/Utils'
//'./newDashboard/algoliaDashboard/AlgoliaMiscUtils'
import { checkAdminEmail } from '../../newDashboard/algoliaDashboard/AlgoliaMiscUtils';


export default class ViewArchives extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user:'',
            archives: [],
        }
    }

    

    componentDidMount() {

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");
            
            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })



        // base.syncState('archives', {
        //     context: this,
        //     asArray: true,
        //     state: 'archives'
        // });


        //ARCHIVE OLD ORDERS 
    // this.sendOrdersToApi();
       //this.cleanUpDeliveries();
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
       // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    /**
    * clean up deliveries
    */
    cleanUpDeliveries = () => {
        console.log("++++++++++++:cleanUpDeliveries");

        base.fetch('orders', {
            context: this,
            asArray: true,
            queries: {
                orderByChild: 'status',
                equalTo: Status.total_loss
            },
            then(data) {
                let allOrders = data;
                console.log("delx1: length:" + allOrders.length);

                let i = 0;
                //for(i=(allOrders.length - 22);i < allOrders.length;i++){
               for (i = 0; i < allOrders.length; i++) {
                    console.log("delx2 - i:" + i + " - " + allOrders[i].order_num);

                    let daysSince = Utils.GetDaysSinceOrderPlaced(allOrders[i].dateNum);
                   // console.log("delx3 allOrders[i].orderId:" + allOrders[i].orderId);
                    console.log("delx3 allOrders[i].key:" + allOrders[i].key);
                    console.log("delx31 daysSince:" + daysSince);

                    if (daysSince > 30) {
                        console.log("delx4  >>> greater than 60:" + daysSince);
                        let tempOrder = allOrders[i];
                        tempOrder.archivedOn = FbUtils.getNowFormatted();
                        tempOrder.archivedBy = this.state.user.email;

                        ref.child('archives/' + allOrders[i].key).set(tempOrder);
                        // console.log("archx newPostKey:" + newPostKey);

                        //DELETE OLD ORDER
                        ref.child('orders/' + allOrders[i].key).set(null);
                        console.log("order "+allOrders[i].order_num+" archived");
                    }

                }
            }
        });
    }

    sendOrdersToApi = () =>{
        console.log("++++++++++++:sendOrdersToApi");

        base.fetch('archives', {
            context: this,
            asArray: true,
            then(data) {
                let allOrders = data;
                console.log("apxARC1: length:"+allOrders.length);
                
                let i=0;
                //for(i=(allOrders.length - 2);i < allOrders.length;i++){
                for(i=0;i <= allOrders.length;i++){
                    console.log("apxARC12 - i:"+i);
                   // console.log("apx121 order:"+allOrders[i].key+" - "+allOrders[i].order_num);

                    sendNewOrder(allOrders[i]);
                }
            }
        });
    }

    render() {

        const archivedOrders = this.state.archives.map((order) =>
            <Grid.Column>
                <OrderCard
                    //user={this.state.userFromFirebaseNode}
                    user={this.state.user}
                    order={order} />
            </Grid.Column>
        )

        return (

            this.state.archives.length === 0 ? <UiConsts.LoadingComponent /> :

            <Container>
                <TopMenu />
                <Grid stackable columns={3}>
                    {archivedOrders}
                </Grid>
            </Container>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Archives/ViewArchives.js